import { graphql } from "gatsby"
import * as React from "react"
import Layout from "../layout"
import { withPrismicPreview } from "gatsby-plugin-prismic-previews"
import SliceRenderer from "../slices"
import Container from "../components/atoms/Container"
import parse from "html-react-parser"
import { PrismicNavigation } from "../layout/PrismicNavigation"
import PrismicFooter from "../layout/PrismicFooter"
import Helmet from "react-helmet"
import { linkResolver } from "../utils/link-resolver"

const Page = (page) => {
  const intro = page?.data?.prismicPage?.data?.intro_text?.html
  const overlineSubtitle = page?.data?.prismicPage?.data?.overline_subtitle
  const title = page?.data?.prismicPage?.data?.title
  const showHeader = page?.data?.prismicPage?.data?.body[0]?.slice_type !== "full_background_hero"
  const url = linkResolver(page?.data?.prismicPage)
  // Check if filterBy parameter exists in URL
  const hasFilterBy = typeof window !== 'undefined' && new URLSearchParams(window.location.search).has('filterBy')

  return (
    <Layout>
      {hasFilterBy && (
        <Helmet>
          <link rel="canonical" href="https://www.roadmapagency.com/resources/" />
        </Helmet>
      )}
      {!hasFilterBy && url && (
        <Helmet>
          <link rel="canonical" href={"https://www.roadmapagency.com" + url} />
        </Helmet>
      )}
      <PrismicNavigation />

      {(!!intro || !!title || !!overlineSubtitle) && showHeader &&
        <Container small  innerProps={{ style: { textAlign: "center" } }}>
          {title &&
            <h1>{title}</h1>
          }
          {overlineSubtitle &&
            <h4 style={{ fontWeight: "normal" }}>{overlineSubtitle}</h4>
          }
          <div style={{ textAlign: "left", maxWidth: "900 px", margin: "0 auto" }}>
          {parse(intro)}
          </div>
        </Container>
      }

      <SliceRenderer doc={page?.data?.prismicPage} />

      <PrismicFooter />
    </Layout>
  )

}

export const query = graphql`
    query singlePage($id: String){
        prismicPage(id: {eq: $id}) {
            __typename
            _previewable
            data {
                slug_prefix
                meta_title
                meta_description
                og_image{
                    url
                    gatsbyImageData(layout: FIXED, width: 1200, height: 627)
                }
                title
                overline_subtitle
                intro_text{
                    html
                }
                body{
                    ...Anchor
                    ...Hero
                    ...Text
                    ...ImageWithText
                    ...Video
                    ...Logos
                    ...Image
                    ...Testimonials
                    ...Person
                    ...CaseStudy
                    ...HubspotForm
                    ...Heading
                    ...HTML
                    ...Locations
                    ...ShadowBox
                    ...IconText
                    ...Callout
                    ...InsightsPage
                    ...FullBackgroundHero
                    ...PricingTable
                    ...ImageScroller
                    ...NonHubspotForm
                    ...RoadsignCallout
                    ...TestimonialV2
                    ...ProblemSolution
                    ...InsightCallout
                    ...YellowSection
                }
            }
            uid
            id
            type
            lang
            alternate_languages {
                id
                lang
            }
        }
    }
`

Page.query = query

export default withPrismicPreview(Page)
